import React from 'react';

function LegalFooter() {
  const handleLegalPageClick = (page) => {
    // Handle special support types
    if (page.includes('?type=')) {
      const [basePage, query] = page.split('?');
      window.location.href = `/${basePage}?${query}`;
    } else {
      // Simple navigation using window.location
      window.location.href = `/${page}`;
    }
  };

  return (
    <footer className="bg-gray-900 border-t border-gray-700 py-8 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <h3 className="text-white font-semibold text-lg">actuvo.ai</h3>
            <p className="text-gray-400 text-sm">
              Maker-only dynamic grid trading bot for Hyperliquid perpetuals.
            </p>
          </div>

          {/* Legal Links */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold">Legal</h4>
            <div className="space-y-2">
              <button 
                onClick={() => handleLegalPageClick('terms')}
                className="block text-gray-400 hover:text-white text-sm transition-colors text-left"
              >
                Terms of Service
              </button>
              <button 
                onClick={() => handleLegalPageClick('privacy')}
                className="block text-gray-400 hover:text-white text-sm transition-colors text-left"
              >
                Privacy Policy
              </button>
              <button 
                onClick={() => handleLegalPageClick('risk-disclaimer')}
                className="block text-gray-400 hover:text-white text-sm transition-colors text-left"
              >
                Risk Disclaimer
              </button>
              <button 
                onClick={() => handleLegalPageClick('cookies')}
                className="block text-gray-400 hover:text-white text-sm transition-colors text-left"
              >
                Cookie Policy
              </button>
            </div>
          </div>

          {/* Support */}
          <div className="space-y-4">
            <h4 className="text-white font-semibold">Support</h4>
            <div className="space-y-2">
              <button 
                onClick={() => handleLegalPageClick('support')}
                className="block text-gray-400 hover:text-white text-sm transition-colors text-left"
              >
                Contact Support
              </button>
              <button 
                onClick={() => handleLegalPageClick('support?type=privacy')}
                className="block text-gray-400 hover:text-white text-sm transition-colors text-left"
              >
                Privacy Questions
              </button>
              <button 
                onClick={() => handleLegalPageClick('support?type=legal')}
                className="block text-gray-400 hover:text-white text-sm transition-colors text-left"
              >
                Legal Inquiries
              </button>
            </div>
          </div>

          {/* Disclaimers */}
          <div className="space-y-4">
            <h4 className="text-red-400 font-semibold">⚠️ Risk Warning</h4>
            <div className="text-xs text-gray-400 space-y-2">
              <p>Trading involves substantial risk of loss.</p>
              <p>Past performance does not guarantee future results.</p>
              <p>Only invest money you can afford to lose.</p>
              <button 
                onClick={() => handleLegalPageClick('risk-disclaimer')}
                className="text-red-400 hover:text-red-300 underline block"
              >
                Read Full Risk Disclaimer
              </button>
            </div>
          </div>
        </div>

        {/* Bottom Section */}
        <div className="border-t border-gray-700 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-gray-400 text-sm">
              © 2026 actuvo.ai. All rights reserved.
            </div>
            
            <div className="flex space-x-6 text-xs text-gray-400">
              <span>Service provided "as is"</span>
              <span>•</span>
              <span>High risk investment</span>
            </div>
          </div>

          {/* Final Warning */}
          <div className="mt-4 p-3 bg-red-900 border border-red-700 rounded text-center">
            <p className="text-red-100 text-xs font-semibold">
              ⚠️ WARNING: Trading financial instruments involves substantial risk of loss. 
              actuvo.ai is not responsible for any trading losses. Use at your own risk.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default LegalFooter;